import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PromiseState } from 'react-refetch';

import LoadingAnimation from './LoadingAnimation';
import ErrorBox from './ErrorBox';

class PromiseStateContainer extends Component {
  render() {
    const { ps, onPending, onNoResults, onRejection, onFulfillment } = this.props;

    if (ps.pending) {
      return onPending(ps.meta);
    } else if (ps.rejected) {
      return onRejection(ps.reason, ps.meta);
    } else if (ps.fulfilled && (Object.keys(ps.value).length === 0 && ps.value.constructor === Object)) {
      return onNoResults(ps.meta);
    } else if (ps.fulfilled) {
      return onFulfillment(ps.value, ps.meta);
    } else {
      throw new Error('invalid promise state');
    }
  }
}

PromiseStateContainer.propTypes = {
  ps: PropTypes.instanceOf(PromiseState).isRequired,
  onPending: PropTypes.func,
  onNoResults: PropTypes.func,
  onRejection: PropTypes.func,
  onFulfillment: PropTypes.func.isRequired,
};

const onPending = (meta) => (<LoadingAnimation meta={meta} />);
const onNoResults = (meta) => (<ErrorBox error="No results" meta={meta} />);
const onRejection = (reason, meta) => (<ErrorBox error={reason} meta={meta} />);

PromiseStateContainer.defaultProps = {
  onPending: onPending,
  onNoResults: onNoResults,
  onRejection: onRejection,
};

export default PromiseStateContainer;



// WEBPACK FOOTER //
// ./src/components/apiAccess/PromiseStateContainer.js